<template>
  <div>
    <Header
            :showRegistrationModal = "showRegistrationModal"
            :showLoginModal = "showLoginModal"
            :settings = "settings"
            @openRegModal ="openRegModal"
            @openLogModal ="openLogModal"
    >
    </Header>
    <main-page
            :loggedUser = loggedUser
            :showModalButtons = showModalButtons
            :showRegistrationModal = "showRegistrationModal"
            :showLoginModal = "showLoginModal"
            :settings = "settings"
            @openRegModal ="openRegModal"
            @openLogModal ="openLogModal"
    >
    </main-page>
  </div>
</template>
<script>
import Header from '../components/global/Header.vue'
import mainPage from '../components/welcomePage/mainPage.vue'
import {mapState} from 'vuex'
import { EventBus } from '../event-bus'

const getSettings = function (settings, lang) {
  let _settings = []
  if (settings) {
    settings.forEach(setting => {
      setting.SettingTranslations.forEach(st => {
        if (!setting.value) {
          setting.value = st.value
        }
        if (st.languageId === lang.id) {
          setting.value = st.value
        }
      })
      _settings.push(setting)
    })
  }
  return _settings
}

export default {
  name: 'WelcomePage',
  components: {
    Header,
    mainPage
  },
  data: () => ({
    settings: [],
    confirmedEmailText: '',
    confirmedEmailType: 'error',
    showRegistrationModal: false,
    showLoginModal: false
  }),
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage,
      loggedUser: state => state.auth.userData,
      showModalButtons: state => state.auth.showModalButtons
    })
  },
  methods: {
    languageChanged (lang) {
      this.settings = getSettings(this.settings, lang)
    },
    openRegModal () {
      this.showRegistrationModal = !this.showRegistrationModal
    },
    openLogModal () {
      this.showLoginModal = !this.showLoginModal
    }
  },
  created () {
    if (['confirmEmail', 'verificationEmail', 'confirmEmailCompany'].includes(this.$route.name)) {
      this.confirmedEmailText = ''
      this.confirmedEmailType = 'error'
      this.$store.dispatch('common/' + this.$route.name, {confirmCode: this.$route.query.code})
        .then((res) => {
          if (res.data) {
            if (res.data.message) {
              this.confirmedEmailText = res.data.message
            }
            if (res.data.type) {
              this.confirmedEmailType = res.data.type
            }
            // Make a toastr with custom properties
            this.$toastr('add', {
              title: this.$t(this.confirmedEmailType), // Toast Title
              msg: this.confirmedEmailText, // Message
              timeout: 100000, // Timeout in ms
              position: 'toast-bottom-left', // Toastr position
              type: this.confirmedEmailType, // Toastr type
              clickClose: true // On click toast close can be boolean; default false
            })
          }
        })
        .catch(console.error)
    }
    this.$store.dispatch('common/getSettings')
      .then((res) => {
        if (res.data && res.data.settings) {
          this.settings = getSettings(res.data.settings, this.activeLanguage)
        }
      })
      .catch(console.error)
    EventBus.$on('language-changed', this.languageChanged)
  }
}
</script>
<style lang="scss">
  .confirm-email-alert {
    top: 100px;
    margin: 0 auto;
    p {
      margin-bottom: 0;
    }
    @media screen and (max-width: 960px){
      top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/WelcomePage.vue